import dayjs, { Dayjs } from "dayjs";
import DatePicker from "react-datepicker";
import { Input } from "../Input";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";

const InputRef = ({ value, onClick, onChange }, ref) => (
  <Input
    onFocus={onClick}
    ref={ref}
    value={value}
    onChange={onChange}
  ></Input>
);
interface Props {
  onChange: (values: [Dayjs, Dayjs], formatString: [string, string]) => void;
  value?: [Dayjs, Dayjs];
  disabled?: boolean;
}

export const TimePickerRangeComponent = ({
  onChange,
  value,
  disabled,
}: Props) => {
  const { theme: connexxTheme } = useSelector((state: RootState) => {
    return state.tableSlice;
  });

  const ExampleCustomInput = forwardRef(InputRef);
  const interval = 15;
  const format = "HH:mm";

  return (
    <div className="flex justify-between items-center space-x-3 w-full">
      <div className="relative"> 
        <DatePicker
          selected={value[0]?.toDate()}
          onChange={(newTime: Date) => {
            onChange([dayjs(newTime), value[1]], [format, format]);
          }}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={interval}
          timeCaption="Time"
          dateFormat={format}
          disabled={disabled}
          customInput={<ExampleCustomInput value={undefined} onClick={undefined} onChange={undefined} />}
          popperPlacement="bottom-start"
          popperClassName={connexxTheme}
        />
      </div>

      <span className="text-gray-500 text-2xl">&#8640;</span>

      <div className="relative"> 
        <DatePicker
          selected={value[1]?.toDate()}
          onChange={(newTime: Date) => {
            onChange([value[0], dayjs(newTime)], [format, format]);
          } }
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={interval}
          timeCaption="Time"
          dateFormat={format}
          disabled={disabled}
          customInput={<ExampleCustomInput value={undefined} onClick={undefined} onChange={undefined} />}
          popperPlacement="bottom-start"
          popperClassName={connexxTheme}
        />
      </div>
    </div>

  );
};
